import { AxiosInstance } from 'axios';

import { observeApiFlows } from './observeApiFlows';
import { FaroSettings, readFaroSettings } from './settings';

/**
 * Liga a observabilidade do front: Faro mais as etapas de negócio das chamadas à `api`.
 *
 * Sem `REACT_APP_FARO_API_KEY` no build, não faz nada. Com a chave, o Faro chega num chunk separado;
 * se o chunk ou a inicialização falharem, o app segue igual e o observador nem é registrado.
 */
export function startObservability(
  apiInstance: AxiosInstance,
  settings: FaroSettings | null = readFaroSettings(),
): Promise<void> {
  if (!settings) return Promise.resolve();

  return import('./faroAgent')
    .then(({ startFaro }) => observeApiFlows(apiInstance, startFaro(settings)))
    .catch(() => {
      // Sem observabilidade o app segue igual; nunca impedir a renderização por causa dela.
    });
}
